<!--
 * @Descripttion: 查看明细-平台服务费/商务服务费
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="order-detail-c">
    <div
      style="
        font-size: 14px;
        color: #121619;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 25px;
      "
    >
      {{ tips }}
    </div>
    <BaseTable :data="dataList" :columns="tableColumns"></BaseTable>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { BaseTable, BaseButton, useTableColumn } from 'xrk-components';

import { orderFeeViewDetail } from '../data-source/apis';
import { getServiceCol } from '../fields/columns';
import { downLoadReceipt } from '@/common/hooks/order/order-download';

const route = useRoute();

const detailInfo = computed(() => {
  return {
    orderId: +route.query.orderId,
    orderType: +route.query.orderType,
    taxPattern: +route.query.taxPattern,
    gysx: +route.query.gysx
  };
});

const tableColsAndTipsInfo = computed<{ cols: any[]; tips: string }>(() => {
  const entry = [
    +route.query.orderType,
    +route.query.gysx,
    +route.query.taxPattern
  ].join('-');
  return getServiceCol(entry);
});
const tableColumns = ref(
  [
    ...tableColsAndTipsInfo.value.cols,
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '操作',
      width: 230,
      render({ row }) {
        return (
          <>
            <div>
              <BaseButton
                disabled={!row.receiptUrl || row.receiptUrl === '-'}
                onClick={async () => {
                  // 下载回单
                  downLoadReceipt(row.receiptUrl);
                }}
                type="text"
              >
                下载回单
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ].filter(Boolean)
);
const dataList = ref([]);
const tips = ref('');
const getListAjax = async () => {
  const reqData = {
    id: detailInfo.value.orderId,
    orderType: detailInfo.value.orderType
  };
  const { data } = await orderFeeViewDetail(reqData);
  tips.value = data.calculationFormula;
  dataList.value = [data];
};
getListAjax();
</script>
<style lang="scss"></style>
